export const SENTRY_INTAKE_SETUP_COPY = {
  pageTitle: "How should Sentry issues become tasks?",
  wizardStepConnect: "Connect Sentry",
  wizardStepConnectHelper: "Install the SuperPlane Sentry app so SuperPlane can read issues and listen for new ones.",
  wizardStepConnectExisting: "Choose the Sentry organization that SuperPlane will monitor.",
  wizardStepProject: "Which Sentry projects should create tasks?",
  wizardStepProjectHelper: "Select one or more projects. SuperPlane listens for new issues.",
  importExistingHelper: "SuperPlane adds up to 3 of the newest unresolved issues from these projects.",
  importExistingHelperOff: "SuperPlane does not import existing issues.",
  wizardConnect: "Connect Sentry",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardProjectsLoading: "Loading Sentry projects...",
  wizardProjectsError: "SuperPlane could not load Sentry projects.",
  wizardProjectsEmpty: "This connection has no available projects.",
  wizardNoMatchingProjects: "No matching projects.",
  unavailableProject: "Not in this connection",
  wizardSearchProjects: "Search projects",
  wizardRetry: "Try again",
  wizardConnectError: "SuperPlane could not open the Sentry install page.",
  wizardCreateError: "SuperPlane could not create the Sentry intake.",
  projectsRequired: "Select at least one Sentry project.",
  projectsLabel: "Projects",
} as const;
